import type {
  QuestCompletion,
  QuestCompletions,
} from "@/components/QuestsV2/types";
import { ONBOARDED_FEED_QUEST_ID } from "@/constants";
import type {
  SignInTemplate,
  SocialConnectionTemplate,
} from "@/domain/gems-game/domain";
import { DiscordLinkedAccountPlatform } from "@/utils/linkedaccounts/discord";
import { XLinkedAccountPlatform } from "@/utils/linkedaccounts/x";

export type DayZeroQuestInfo = {
  isDay0: boolean;
  remainingTime: number;
};

const EIGHT_HOURS_MS = 8 * 60 * 60 * 1000;

export const getDayZeroQuestInfo = (
  completedQuests: QuestCompletions | undefined,
): DayZeroQuestInfo => {
  if (!completedQuests) return { isDay0: false, remainingTime: 0 };

  const onboardedQuest = Object.values(completedQuests).find(
    (quest: QuestCompletion) => quest.external_id === ONBOARDED_FEED_QUEST_ID,
  );

  if (!onboardedQuest) return { isDay0: false, remainingTime: 0 };

  const completionTime = new Date(
    onboardedQuest.latest_completion_time,
  ).getTime();
  const now = Date.now();
  const timeElapsed = now - completionTime;
  const isDay0 = timeElapsed < EIGHT_HOURS_MS;

  if (!isDay0) return { isDay0: false, remainingTime: 0 };

  return {
    isDay0: true,
    remainingTime: EIGHT_HOURS_MS - timeElapsed,
  };
};

export const DiscordConnectionItem: SocialConnectionTemplate = {
  type: "socialconnection",
  id: "discord-connection",
  quest: {
    questId: "discord-connection",
    gemsEarnable: 50,
  },
  platform: DiscordLinkedAccountPlatform,
  priority: 21,
  bypass: false,
  categories: ["social"],
  tags: ["discord", "social", "connect"],
  createdAt: new Date("2025-05-21"),
};

export const XConnectionItem: SocialConnectionTemplate = {
  type: "socialconnection",
  id: "x-connection",
  quest: {
    questId: "x-connection",
    gemsEarnable: 50,
  },
  platform: XLinkedAccountPlatform,
  priority: 20,
  bypass: false,
  categories: ["social"],
  tags: ["x", "social", "connect"],
  createdAt: new Date("2025-05-21"),
};

export const getSignInItem = (): SignInTemplate => ({
  type: "signin",
  id: "signin",
  quest: { questId: "signin", gemsEarnable: 0 },
  priority: 0,
  bypass: false,
  categories: ["signin"],
  tags: ["signin"],
  createdAt: new Date("2025-05-28"),
});

export const ContentContainer = ({
  children,
}: { children: React.ReactNode }) => {
  return (
    <div
      style={{
        height: "100%",
        scrollSnapAlign: "start",
        position: "relative",
        scrollSnapStop: "always",
        scrollBehavior: "smooth",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );
};
